/****************************************************
 * Module Name:  addPurchaseModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import React, { Component } from "react";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import logo from '../../images/pansuriya.jpg'
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField, Tooltip, Typography } from "@mui/material";
import Select from "react-select";
import CommonSnackbar from "../common/commonSnackBar";
import MixBucketProxy from "../../utility/proxy/manager/mixProxy/mixBucketProxy";
import Utility from "../../utility/utility";
import UserProxy from "../../utility/proxy/manager/userProxy";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { LoadingButton } from "@mui/lab";
import dayjs from "dayjs";
import SaveIcon from '@mui/icons-material/Save';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import UserDetailModal from "../operations/userDetailModal";

export default class AddPurchaseModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newBucket: this.props.editOperation
        ? {
          value: this.props.sourceData.id,
          label:
            this.props.sourceData.stonetypefullname +
            " | " +
            this.props.sourceData.shape +
            " | " +
            this.props.sourceData.size +
            " | " +
            this.props.sourceData.color +
            " | " +
            this.props.sourceData.clarity,
        }
        : "",
      newCustomer: "",
      newDate: new Date(),
      newQty: 0,
      newPrice: 0,

      showError: false,

      bucketOptions: [],
      showBucketLoadSpinner: true,

      customerOptions: [],
      showCustomerLoadSpinner: true,

      qtyValidationError: "",
      priceValidationError: "",

      showUserDetailModal: false,
      userIds: [],
    };
    this.getAllCustomer(false);
    if (!this.props.editOperation) {
      this.getAllBucket(false);
    }
  }

  getAllBucket = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showBucketLoadSpinner: true });
    MixBucketProxy.GetAllBucketDetailMini((response) =>
      this.setAllBucketData(response)
    );
  };

  setAllBucketData = (response) => {
    let optionsArray = [];
    response.map((data) => {
      let option = {
        value: data.id,
        label:
          data.stonetypefullname +
          " | " +
          data.shape +
          " | " +
          data.size +
          " | " +
          data.color +
          " | " +
          data.clarity,
      };
      optionsArray.push(option);

      return true;
    });
    this.setState({
      bucketOptions: optionsArray,
      showBucketLoadSpinner: false,
      newBucket:
        this.state.newBucket === "" && optionsArray.length > 0
          ? optionsArray[0]
          : this.state.newBucket,
    });
  };

  getAllCustomer = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showCustomerLoadSpinner: true });
    UserProxy.GetAllUserDetailCustomer((response) =>
      this.setAllCustomerData(response)
    );
  };

  setAllCustomerData = (response) => {
    let optionsArray = [];
    response.map((data) => {
      let option = { value: data.id, label: data.id + " | " + data.companyname };
      optionsArray.push(option);

      return true;
    });
    this.setState({
      customerOptions: optionsArray,
      showCustomerLoadSpinner: false,
      newCustomer:
        this.state.newCustomer === "" && optionsArray.length > 0
          ? optionsArray[0]
          : this.state.newCustomer,
      userIds: optionsArray.map(cust => cust.value)
    });
  };

  handleSave = () => {
    let data = {
      id: undefined,
      bucketid: this.state.newBucket.value,
      customerid: this.state.newCustomer.value,
      date:
        Utility.ConvertLocalTimeToUtc(this.state.newDate).slice(0, 11) +
        "00:00:00.000Z",
      qty: parseFloat(this.state.newQty).toFixed(2),
      price: parseFloat(this.state.newPrice).toFixed(2),
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) this.props.handleSave(data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  buttonDisable = () => {
    if (
      this.state.qtyValidationError.length !== 0 ||
      this.state.priceValidationError.length !== 0 ||
      !this.state.newPrice ||
      !this.state.newQty
    )
      return true;

    return false;
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add bucket validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />
        {this.state.showUserDetailModal ? (
          <UserDetailModal
            show={true}
            handleClose={() => this.setState({ showUserDetailModal: false })}
            handleSelect={(selectedOption) => {
              const selectedCustomers = this.state.customerOptions.filter(opt =>
                selectedOption.includes(opt.value)
              );
              this.setState({ newCustomer: selectedCustomers[0], showUserDetailModal: false })
            }}
            userids={this.state.userIds}
            selectedIds={this.state.newCustomer.value !== "" ? [this.state.newCustomer.value] : []}
            usertype={"C"}
            loading={this.state.showUserDetailModal}
            isMulti={false}
          />
        ) : null}
        <Modal
          backdrop="static"
          show={this.props.show}
          onHide={this.props.handleClose}
          customer="lg"
          enforceFocus={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;Add Purchase
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Box
              sx={{
                width: "100%",
                "& .css-2vawn2-MuiTypography-root": {
                  alignSelf: "center",
                },
              }}
            >
              <Box sx={{ display: "flex", mt: 2 }}>
                <Typography sx={{ width: "25%", alignSelf: "center" }}>
                  Bucket
                </Typography>

                {this.props.editOperation ? (
                  <Typography>{this.state.newBucket.label}</Typography>
                ) : (
                  <>
                    <Box sx={{ width: "79%" }}>
                      <Select menuPlacement="auto"
                        blurInputOnSelect={false}
                        className="basic-single"
                        classNamePrefix="select"
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value}
                        value={this.state.newBucket}
                        isSearchable={true}
                        name="Bucket"
                        menuPortalTarget={document.body}
                        styles={Constants.Styles}
                        options={this.state.bucketOptions}
                        onChange={(selectedOption) =>
                          this.setState({
                            newBucket: selectedOption,
                          })
                        }
                      />
                    </Box>
                    {this.state.showBucketLoadSpinner ? (
                      <CircularProgress size="1em" sx={{ mt: 1.5, ml: 0.7 }} />
                    ) : (
                      <Tooltip title="Reload">
                        <RefreshOutlinedIcon
                          color="primary"
                          fontSize="medium"
                          onClick={() => this.getAllBucket(true)}
                          sx={{ cursor: "pointer", mt: 1 }}
                        />
                      </Tooltip>
                    )}
                  </>
                )}
              </Box>
              <Box sx={{ display: "flex", mt: 2 }}>
                <Typography sx={{ width: "23%", alignSelf: "center" }}>
                  Customer
                </Typography>

                <Box sx={{ width: "79%", display: "flex", alignItems: "center" }}>
                  <Box sx={{ flexGrow: 1 }}>
                    <Select menuPlacement="auto"
                      blurInputOnSelect={false}
                      className="basic-single"
                      classNamePrefix="select"
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      value={this.state.newCustomer}
                      isSearchable={true}
                      name="Customer"
                      menuPortalTarget={document.body}
                      styles={Constants.Styles}
                      options={this.state.customerOptions}
                      onChange={(selectedOption) => {
                        this.setState({
                          newCustomer: selectedOption,
                        })
                      }
                      }
                    />
                  </Box>
                  <Tooltip title="View More Data">
                    <span style={{ cursor: "pointer", marginLeft: "8px" }}>
                      <OpenInNewIcon
                        fontSize="medium"
                        onClick={() => this.setState({ showUserDetailModal: true })}
                        color="action"
                      />
                    </span>
                  </Tooltip>
                  {this.state.showCustomerLoadSpinner ? (
                    <CircularProgress size="1em" sx={{ mt: 1.5, ml: 0.7 }} />
                  ) : (
                    <Tooltip title="Reload">
                      <RefreshOutlinedIcon
                        color="primary"
                        fontSize="medium"
                        onClick={() => this.getAllCustomer(true)}
                        sx={{ cursor: "pointer", mt: "3px" }}
                      />
                    </Tooltip>
                  )}
                </Box>
              </Box>
              <Box display={"flex"} gap="15px" mt={2}>
                {" "}
                <Typography mt={2} sx={{ width: "25%" }}>
                  Date
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    ampm={true}
                    renderInput={(props) => (
                      <TextField
                        fullWidth
                        {...props}
                        inputProps={{ ...props.inputProps, readOnly: true }}
                      />
                    )}
                    error={false}
                    value={this.state.newDate}
                    inputFormat="DD/MM/YYYY"
                    size="small"
                    onChange={(newValue) => {
                      // Get the current time
                      const now = dayjs();

                      // Set startOfMonth to the first day of the selected month, but with the current system time
                      const newDate = dayjs(newValue)
                        .hour(now.hour())
                        .minute(now.minute())
                        .second(now.second())
                        .millisecond(now.millisecond())
                        .toDate();

                      this.setState({ newDate: newDate });
                    }}
                    maxDate={new Date()}
                  />
                </LocalizationProvider>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography sx={{ width: "29%" }}>
                  Quantity <sup style={{ color: "red" }}>*</sup>
                </Typography>
                <TextField
                  margin="normal"
                  customer="small"
                  fullWidth
                  type={"number"}
                  label="Quantity (carats) (required)"
                  placeholder="Enter Quantity"
                  value={this.state.newQty}
                  size="small"
                  onChange={(e) =>
                    this.setState({
                      newQty: e.target.value,
                      qtyValidationError: Utility.CheckisNumberPositive(
                        e.target.value
                      )
                        ? ""
                        : "Quantity Should not be a negative number ",
                    })
                  }
                  helperText={this.state.qtyValidationError}
                  error={this.state.qtyValidationError.length > 0}
                />
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography sx={{ width: "29%" }}>
                  Price <sup style={{ color: "red" }}>*</sup>
                </Typography>
                <TextField
                  margin="normal"
                  customer="small"
                  fullWidth
                  type={"number"}
                  label="Price (required)"
                  size="small"
                  placeholder="Enter Price"
                  value={this.state.newPrice}
                  onChange={(e) =>
                    this.setState({
                      newPrice: e.target.value,
                      priceValidationError: Utility.CheckisNumberGreaterThanZero(
                        e.target.value
                      )
                        ? ""
                        : "Price Should be greater than 0",
                    })
                  }
                  helperText={this.state.priceValidationError}
                  error={this.state.priceValidationError.length > 0}
                />
              </Box>
            </Box>
          </Modal.Body>
          <Modal.Footer>
            <LoadingButton
              loading={this.props.loading}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              onClick={() => this.handleSave()}
              disabled={this.buttonDisable()}
              sx={{ mr: 1 }}
            >
              Save
            </LoadingButton>
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
